import { render, staticRenderFns } from "./NewZone.vue?vue&type=template&id=1f4942f0&scoped=true&"
import script from "./NewZone.vue?vue&type=script&lang=js&"
export * from "./NewZone.vue?vue&type=script&lang=js&"
import style0 from "./NewZone.vue?vue&type=style&index=0&id=1f4942f0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4942f0",
  null
  
)

export default component.exports